import React, { useState } from 'react';
import { Col, Row, Table, Input, Button, Space } from "antd";
import {DeleteOutlined} from "@ant-design/icons";

export interface PredefinedVariable {
    key: string,
    value: string
}

interface PredefinedVariablesProps {
    variables: { [key: string]: string; },
    canEdit: boolean,
    onPredefinedVariables: (predefinedVariable: PredefinedVariable) => void;
    onRemoveVariable: (key: string) => void;
}

const PredefinedVariablesTab: React.FC<PredefinedVariablesProps> = ({ variables, canEdit, onPredefinedVariables, onRemoveVariable }) => {
    const [newKey, setNewKey] = useState("");
    const [newValue, setNewValue] = useState("");

    const columns = [
        {
            title: 'Variable',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: 'Wert',
            dataIndex: 'value',
            key: 'value',
        },
        {
            title: 'Löschen',
            key: 'delete',
            render: (text, record) => (
                canEdit && (
                    <Button type="primary" danger onClick={() => onRemoveVariable(record.key)}>
                        <DeleteOutlined />
                    </Button>
                )
            ),
        },
    ];

    const dataSource = Object.entries(variables).map(([key, value]) => ({ key, value }));

    const handleSubmit = () => {
        if (newKey && newValue) {
            onPredefinedVariables({ key: newKey, value: newValue });
            setNewKey("");
            setNewValue("");
        }
    };

    return (
        <Row gutter={[16, 16]}>
            <Col span={24}>
                <Table columns={columns} dataSource={dataSource} pagination={false} locale={{ emptyText: 'Keine Daten vorhanden' }} />
            </Col>
            {canEdit && (
                <>
                    <Col span={12}>
                        <Input
                            placeholder="Variable"
                            value={newKey}
                            onChange={(e) => setNewKey(e.target.value)}
                        />
                    </Col>
                    <Col span={12}>
                        <Input
                            placeholder="Wert"
                            value={newValue}
                            onChange={(e) => setNewValue(e.target.value)}
                        />
                    </Col>
                    <Col span={24} style={{ textAlign: 'center' }}>
                        <Button onClick={handleSubmit}>Hinzufügen</Button>
                    </Col>
                </>
            )}
        </Row>
    );
}

export default PredefinedVariablesTab;
